import { render, staticRenderFns } from "./groupLeaderBasic.vue?vue&type=template&id=3e41e392&scoped=true"
import script from "./groupLeaderBasic.vue?vue&type=script&lang=js"
export * from "./groupLeaderBasic.vue?vue&type=script&lang=js"
import style0 from "./groupLeaderBasic.vue?vue&type=style&index=0&id=3e41e392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e41e392",
  null
  
)

export default component.exports